export default {
  protocol: {
    PCS108: "ฉันเห็นด้วย และอ่านมัน",
    PCS109: "《โพรโทคอลการประมวลผลข้อมูล》",
    PCS110: "《การปกป้องข้อมูลส่วนบุคคล และนโยบายความเป็นส่วนตัว》",
    PCS112: "นูแท็ก และเลือกโปรโตคอล",
    PCS113: "และ",
  },

data: {
  private_agree: `Personal Information Protection and Privacy Policy`,
      private_agree_text: `
    <p><span style="font-size: 14px;"> This policy applies only to Nutag Products or services.</span></p>
    <p><span style="font-size: 14px;"> Last updated:2024Year10moon.</span></p>
    <p><span style="font-size: 14px;"> If you have any questions, comments or suggestions, please contact us through the following contact information:</span></p>
    <p><span style="font-size: 14px;"> e-mail:support@zkdigimax.com.</span></p>
    <p style="margin-top: 30px;"><span style="font-size: 14px;"> This policy will help you understand the following:</span></p>

    <p style="margin-top: 30px;"><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">Rules for the collection and use of personal information</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">How we protect your personal information</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">Your rights</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">How do we handle personal information of
            minors?</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">How this Policy is Updated</span></p>
    <p><span style="display: inline-block;width: 10px;height: 10px; background-color: black; 
        margin-right: 15px; "></span><span style="font-size: 14px;">How to Contact Us</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">ZKTechnology Co., Ltd.and its affiliates(hereinafter referred to as "ZKTechnology", "the Company" or "we") is fully aware of the importance of personal information to you and will do our best to protect your personal information safely and reliably. We are committed to maintaining your trust in us and abiding by the following principles to protect your personal information: the principle of consistency of rights and responsibilities, the principle of clear purpose, the principle of choice and consent, the principle of minimum necessity, the principle of ensuring security, the principle of subject participation, the principle of openness and transparency, etc. At the same time, ZKTechnology promises that we will take corresponding security protection measures to protect your personal information in accordance with the industry's mature security standards.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">Before using this product (or service), please be sure to read and thoroughly understand this policy, and use the relevant products or services after confirming that you fully understand and agree to it. Once you start using this product or service, it means that you have fully understood and agreed to this policy.</span></p>
    <p style="margin-top: 35px;"><strong><span style="font-size: 14px;">1. Rules for the collection and use of personal information</span></strong></p>
    <p style="margin-top: 20px;"><strong><span style="font-size: 14px;">1. What personal information do we collect?</span></strong></p>
    <p style="margin-top: 20px; text-indent: 2em"><span style="font-size: 14px;">1. Your use Nutag, we will collect the following information from you:</span></p>


    <p style="text-indent: 2em"><span style="font-size: 14px;">The business functions we provide rely on some information to operate. If you choose to use this business function, you need to provide us with or allow us to collect the necessary information including:Username (name/nickname/alias/code), phone number, email address.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px;">Depending on the software product you choose, you can optionally enter your mobile phone number/Name. You need to use your email address as your account when logging in. You must provide your real email address to use related services.</span></p>
    <p style="margin-top: 20px; text-indent: 2em"><span style="font-size: 14px;">2. You may choose to provide us with or allow us to collect the following information:Personal photos, residential address, company, IP address information, MAC address information, access date and time.</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">This information is not necessary for the operation of the business function, but it is of great significance to improving service quality, developing new products or services, etc. We will not force you to provide this information, and your refusal will not have an adverse impact on the use of this business function.</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">3. When you use this business function, our software will apply to you for the following system permissions related to personal information:Get location.</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">If you do not authorize, we will not be able to provide the business function. In addition to the above permissions, you can choose whether to grant other system permissions to the software.</span></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">When you contact us, we may save your communication/call records and content or information such as the contact information you leave in order to contact you or help you solve the problem, or record the solution and results of the relevant problem.</span></p>

    <p><strong><span style="font-size: 14px;">(II) How we use your personal information</span></strong></p>
    <p style="text-indent: 2em;"><span style="font-size: 14px;">1. We will use the necessary personal information to provide this business function. We will also use the following information to maintain and improve this business function, develop new business functions, etc.</span></p>
    <table style="width: auto; border-collapse: collapse;  margin: 0 auto;">
        <tbody>
            <tr>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Information Type
                </td>

                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Purpose of Use
                </td>

                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Shelf life
                </td>
            </tr>

            <tr>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Username (name/nickname/alias/code),telephone number,Mail
                </td>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Record account information
                </td>
                <td colSpan="1" rowSpan="1" width="225"
                    style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
                    Permanent (deleted upon account cancellation)
                </td>
            </tr>
        </tbody>
    </table>

  
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">(III) How we use cookies and similar technologies</span></strong>
    </p>

    <p>
        <span style="font-size: 14px">1. Cookies</span>
    </p>
    <p style="text-indent: 2em">
        <span style="font-size: 14px">Cookies and similar technologies are commonly used on the Internet. To ensure the normal operation of the website, we will store small data files called cookies on your computer or mobile device. Cookies usually contain identifiers, site names, and some numbers and characters. With the help of cookies, websites can store data such as your preferences. We will not use cookies for any purpose other than those described in this policy. You can manage or delete cookies according to your preferences. You can clear all cookies saved on your computer, and most web browsers have the function of blocking cookies. But if you do this, you need to change the user settings yourself every time you visit our website.</span>
    </p>
    <p>
        <span style="font-size: 14px">2. Other similar technologies</span>
    </p>

    <p style="text-indent: 2em">
        <span style="font-size: 14px">In addition to Cookies, we will also use other similar technologies such as web beacons and pixel tags on our websites to help us understand your product or service preferences and improve customer service.</span>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px"></span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px"></span></strong>
    </p>

    <p>
        <span style="font-size: 14px">(Four)Cloud PlatformSafety Responsibility</span>
    </p>

    <p style="text-indent: 2em">
        <span style="font-size: 14px">1,ZK is responsible for the security management and operation of services and data interactions on the ZK cloud platform, and is responsible for the security of the cloud service platform and infrastructure provided.APIinterface,SDKFor self-developed software or hardware embedded software, customers need to ensure the security and compliance of their applications and data, including hardware equipment and software, when connected to Enbase Cloud Platform. Enbase Cloud’s main responsibility is to develop and operate various basic services, platform services and application services, while customers’ main responsibility is to customize and develop third-party clients and build third-party cloud services based on Enbase Cloud services. The following figure shows the shared responsibility model for basic cloud service providers, Enbase and customer information security responsibilities.</span>
    </p>

 <table style="width: 100%; height: 100vh; border-collapse: collapse">
    <tr>
      <th
        rowspan="11"
        style="
          border: 1px solid black;
          text-align: center;
          writing-mode: vertical-rl;
          background-color: #f4f4f4;
          height: 100vh;
        "
      >
        Security Operation Management
      </th>
      <th
        colspan="3"
        style="
          border: 1px solid black;
          text-align: center;
          background-color: #f4f4f4;
        "
      >
        Rongji Cloud Platform, Software, Embedded Software
      </th>
      <th
        rowspan="12"
        style="
          border: 1px solid black;
          text-align: center;
          writing-mode: vertical-rl;
          background-color: #f4f4f4;
          height: 100vh;
        "
      >
        Authentication&nbsp;&nbsp;/ Access Control&nbsp;&nbsp;/ Permissions Control
      </th>
    </tr>

    <!-- Second row, six cells divided into two rows and three columns -->
    <tr>
      <td style="border: 1px solid black; text-align: center">
        Third-Party Client
      </td>
      <td style="border: 1px solid black; text-align: center">
        Hardware / Embedded Software
      </td>
      <td style="border: 1px solid black; text-align: center">Third-Party Cloud</td>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: center">API / SDK</td>
      <td style="border: 1px solid black; text-align: center">Module / SDK</td>
      <td style="border: 1px solid black; text-align: center">API / SDK</td>
    </tr>

    <!-- Third row, highlighted background -->
    <tr style="background-color: #e9f5e9">
      <td colspan="3" style="border: 1px solid black; text-align: center">
        Rongji Cloud
      </td>
    </tr>
    <!-- Fourth row -->
    <tr>
      <td style="border: 1px solid black; text-align: center">
        Identity Verification Management
      </td>
      <td style="border: 1px solid black; text-align: center">Entrance/Exit Management</td>
      <td style="border: 1px solid black; text-align: center">Office Management</td>
    </tr>
    <!-- Fifth row, highlighted background -->
    <tr style="background-color: #e9f5e9">
      <td colspan="3" style="border: 1px solid black; text-align: center">
        Data Services
      </td>
    </tr>
    <!-- Sixth row -->
    <tr>
      <td style="border: 1px solid black; text-align: center">Storage</td>
      <td style="border: 1px solid black; text-align: center">Database</td>
      <td style="border: 1px solid black; text-align: center">Data Isolation</td>
    </tr>
    <!-- Seventh row -->
    <tr>
      <td style="border: 1px solid black; text-align: center">Log Service</td>
      <td style="border: 1px solid black; text-align: center">Data Analysis</td>
      <td style="border: 1px solid black; text-align: center"></td>
    </tr>
    <!-- Eighth row, highlighted background -->
    <tr style="background-color: #e9f5e9">
      <td colspan="3" style="border: 1px solid black; text-align: center">
        Infrastructure
      </td>
    </tr>
    <!-- Ninth row -->
    <tr>
      <td style="border: 1px solid black; text-align: center">Tencent Cloud</td>
      <td style="border: 1px solid black; text-align: center">AWS</td>
      <td style="border: 1px solid black; text-align: center">Alibaba Cloud</td>
    </tr>
    <!-- Tenth row, highlighted background -->
    <tr style="background-color: #e9f5e9; border: 1px solid black">
      <td style="border: 1px solid black; text-align: center">
        Rongji and Infrastructure Shared Responsibility
      </td>
      <td style="border: 1px solid black; text-align: center">Rongji Cloud Responsibility</td>
      <td style="border: 1px solid black; text-align: center">Customer Responsibility</td>
    </tr>
  </table>





    <p style="text-indent: 2em">
        <span style="font-size: 14px">2, ZK Cloud's security responsibilities</span>
    </p>
    <p>
        <span style="font-size: 14px">a) &nbsp;&nbsp;ZK Cloud selects world-renowned cloud hosting service providers such as Amazon, Tencent Cloud, Alibaba Cloud and other first-class cloud computing platforms to ensure the security of infrastructure and physical equipment for secure management and operation.</span>
    </p>

    <p>
        <span style="font-size: 14px">b) &nbsp;&nbsp;ZK Cloud Security covers data security and cloud service security. ZK promises to use its security team and the professional attack protection technology experience of world-renowned security service providers to provide cloud platform security operation and maintenance services, effectively protect the secure operation of ZK Cloud, and ensure the privacy and data security of customers and users. Including but not limited to:</span>
    </p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">Data security: refers to the security management of customers' business data in the cloud business environment, including collection and identification, classification and grading, permissions and encryption, and privacy compliance.</span></p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">Access control management: management of access rights to resources and data, including user management, permission management, identity authentication, etc.;</span></p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div><span style="font-size: 14px;margin-left: 15px;">Cloud service security: refers to the security management of business-related application systems in a cloud computing environment, including the design, development, release, configuration and use of applications and service interfaces.</span></p>
   
    <p style="text-indent: 2em">
        <span style="font-size: 14px">3, Customer's safety responsibilities</span>
    </p>
    <p><span style="font-size: 14px">a) &nbsp;&nbsp;When using ZK Cloud solutions, customers need to strictly follow ZK's security configuration and access requirements. At the same time, customers need to ensure the security of their own cloud, client or hardware products.</span></p>
    <p><span style="font-size: 14px">b) &nbsp;&nbsp;ZK-basedSDK/APIFor the application software developed, ZK only provides technical support but cannot provide security guarantee for the software as a whole.</span>
    </p>
    <p><span style="font-size: 14px">c) &nbsp;&nbsp;For data security compliance, privacy policy and other related information of customized products based on ZK solutions, the customer is responsible for the privacy policy statement and legal compliance. When necessary, ZK's security compliance team is willing to provide assistance and consulting services for security solutions.</span></p>
    <p><span style="font-size: 14px"></span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">(five)How we share, transfer and publicly disclose your personal information</span></strong>
    </p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">1. Sharing</span></strong>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px">We will not share your personal information with any company, organization or individual outside of our company unless we have your explicit consent.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">We may share your personal information with external parties in accordance with laws and regulations or the mandatory requirements of government authorities. </span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">2. Transfer</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">We will not transfer your personal information to any company, organization or individual, except in the following circumstances:</span></p>
    <p><span style="font-size: 14px">a) &nbsp;&nbsp;Transfer with explicit consent: We will transfer your personal information to other parties with your explicit consent;</span></p>
    <p><span style="font-size: 14px">b) &nbsp;&nbsp;In the event of a merger, acquisition or bankruptcy liquidation, if personal information is transferred, we will require the new company or organization that holds your personal information to continue to be bound by this personal information protection policy. Otherwise, we will require the company or organization to re-solicit your authorization and consent.</span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">3. Public Disclosure</span></strong>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px">We will only disclose your personal information in the following circumstances:</span></p>
    <p><span style="font-size: 14px">c) &nbsp;&nbsp;With your explicit consent;</span></p>
    <p><span style="font-size: 14px">d) &nbsp;&nbsp;Disclosure based on law: We may disclose your personal information publicly when required by law, legal process, litigation or government authorities, including:</span></p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
<span style="font-size: 14px;margin-left: 15px;">Related to the personal information controller's
            performance of obligations prescribed by laws and regulations;</span>
    </p>

    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
<span style="font-size: 14px; margin-left: 15px;">Related to the personal information controller's performance of obligations prescribed by laws and regulations;</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
 <span style="font-size: 14px; margin-left: 15px;">Directly related to national security and national defense security;</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
<span style="font-size: 14px; margin-left: 15px;">Directly related to public safety, public health, and major public interests;</span>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
    <span style="font-size: 14px; margin-left: 15px;">Directly related to criminal investigation, prosecution, trial and execution of judgment;/span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
<span style="font-size: 14px; margin-left: 15px;">For the purpose of protecting the life, property and other major legitimate rights and interests of the personal information subject or other individuals, but it is difficult to obtain the authorization and consent of the individual;</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
  <span style="font-size: 14px; margin-left: 15px;">The personal information involved is disclosed to the public by the subject of personal information on his/her own accord;</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
  <span style="font-size: 14px; margin-left: 15px;">Necessary for entering into and performing a contract at the request of the Personal Information Subject;</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
  <span style="font-size: 14px; margin-left: 15px;">Collecting personal information from legally disclosed information, such as legal news reports, government information disclosure, etc.</span>
    </p>


    <p>
    <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
        </div>
        <div
            style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
        </div>
    </div>
   <span style="font-size: 14px; margin-left: 15px;">Necessary to maintain the safe and stable operation of the products or services provided, such as discovering and handling product or service failures;</span>
    </p>

    <p>
        <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
            </div>
            <div
                style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
            </div>
        </div>
      <span style="font-size: 14px; margin-left: 15px;">The controller of personal information is a news organization, and the personal information is necessary for its legitimate news reporting;</span>
        </p>

        

        <p>
            <div class="star-icon" style="width: 10px; height: 10px; position: relative; display: inline-block;">
                <div
                    style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(45deg);">
                </div>
                <div
                    style="content: ''; position: absolute; width: 100%; height: 100%; border: 1px solid black; border-radius: 2px; transform: rotate(-45deg);">
                </div>
            </div>
            <span style="font-size: 14px; margin-left: 15px;">The controller of personal information is an academic research institution. When it is necessary to conduct statistical or academic research for the public interest and when it provides the results of academic research or descriptions to the outside, the personal information contained in the results will be de-identified.</span>
            </p>

    <p style="text-indent: 2em"><span style="font-size: 14px"></span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px"></span></strong>
    </p>


    <p style="margin-top: 25px;text-indent: 2em">
        <span style="font-size: 14px">Please note that according to legal provisions, sharing and transferring de-identified personal information, while ensuring that the data recipient cannot restore and re-identify the personal information subject, does not constitute external sharing, transfer or public disclosure of personal information, and the storage and processing of such data will not require additional notification to you and your consent.</span>
    </p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">二、How we protect your personal information</span></strong>
    </p>

    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">(I) We value the security of personal data. We use appropriate physical, administrative and technical safeguards to protect your personal data from unauthorized access, disclosure, use, modification, damage or loss. For example, we use encryption technology to ensure the confidentiality of data; we use protection mechanisms to prevent data from malicious attacks; we deploy access control mechanisms to ensure that only authorized personnel can access personal data; and we hold security and privacy protection training courses to enhance employees' awareness of the importance of protecting personal data. We will do our best to protect your personal data, but please note that no security measures can be impeccable.</span></p>
    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">(II) We will retain your personal data for the period necessary to achieve the purposes described in this policy, unless the retention period needs to be extended or is permitted by law. Because the storage period of data may vary based on different scenarios and products and services, the standards we use to determine the retention period include: the time it takes to retain personal data to complete the business purpose, including providing products and services, maintaining corresponding transaction and business records, controlling and improving product and service performance and quality, ensuring the security of systems, products and services, responding to possible user inquiries or complaints, problem location, etc.; whether the user agrees to a longer retention period; whether there are special requirements for retaining data under laws, contracts, etc. As long as your account is necessary to provide you with services, we will retain your registration information. You can also choose to cancel your account. After you cancel your account, we will stop providing products and services based on the account and delete your corresponding personal data unless there are special legal requirements.</span></p>
    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">(III) In the unfortunate event of a personal information security incident, we will inform you in accordance with the requirements of laws and regulations (within 30 natural days at the latest): the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, suggestions for you to prevent and reduce risks on your own, and remedial measures for you, etc. We will inform you of the relevant circumstances of the incident by email, letter, phone, push notification, etc. When it is difficult to inform the subject of personal information one by one, we will take reasonable and effective means to issue an announcement. At the same time, we will also report the disposal of the personal information security incident in accordance with the requirements of the regulatory authorities.</span></p>
    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">(IV) The Internet environment is not 100% secure. Although we have these security measures, please note that there are no "perfect security measures" on the Internet. We will do our best to ensure the security of your information.</span></p>
    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">(V) To ensure a smooth browsing experience, you may receive content or web links from third parties outside of us and our partners (hereinafter referred to as "third parties"). We have no control over such third parties. You can choose whether to access the links, content, products and services provided by third parties. We cannot control the privacy and data protection policies of third parties, and such third parties are not bound by this Policy. Before submitting personal information to a third party, please refer to the privacy protection policy of the third party.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px"></span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px"></span></strong>
    </p>


    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">三、Your rights</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">According to China's relevantlaw, regulations, standards, and common practices in other countries and regions, we guarantee that you can exercise the following rights over your personal information:</span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">(一) &nbsp;&nbsp;Accessing your personal information</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">You have the right to access your personal information, except for exceptions provided by laws and regulations. If you want to exercise your right to access data, you can access it yourself in the following ways:Log in to the software platform to view personal information.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">If you are unable to access this personal information through the above link, you can always send an email toSupport@zkdigimax.com</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">CWe will provide you with other personal information generated during your use of our products or services as long as it does not require us to make excessive efforts. If you want to exercise your data access rights, please send an email toSupport@zkdigimax.com</span></p>
   
   
    <p><strong><span style="font-size: 14px">(二)Correcting your personal information</span></strong>
    <p style="text-indent: 2em"><span style="font-size: 14px">If you find that the personal information we process about you is wrong, you have the right to ask us to make corrections. You can make a correction request through the methods listed in "(I) Accessing Your Personal Information".</span>
    <p style="text-indent: 2em"><span style="font-size: 14px">If you are unable to correct your personal information through the above link, you can always send an email toSupport@zkdigimax.com</span>

  
  
  
  
    </p>
        <strong><span style="font-size: 14px">(三) &nbsp;&nbsp;Deleting your personal information</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">In the following circumstances, you may submit a written request to us to delete your personal information:</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">1、If our handling of personal information violates laws and regulations;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">2、If we collect and use your personal information without your consent;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">3、If our processing of personal information violates our agreement with you;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">4、If you no longer use our products or services, or you cancel your account;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">5、If we no longer provide products or services to you.</span></p>
    <p style="text-indent: 2em; margin-top: 25px;"><span style="font-size: 14px">Where required by applicable law, you also have the right to withdraw your consent at any time when we process your personal data based on your consent. However, the withdrawal of consent will not affect the lawfulness and validity of our processing of your personal data based on your consent before the withdrawal, nor will it affect our processing of your personal data based on other appropriate legitimate bases.</span></p>

  
  
    <p style="margin-top: 25px">
        <strong><span style="font-size: 14px">(四) &nbsp;&nbsp;Respond to your above request</span></strong>
    </p>

    <p style="text-indent: 2em"><span style="font-size: 14px">For security reasons, you may need to provide a written request or otherwise prove your identity. We may ask you to verify your identity before processing your request.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">We will 7skyIf you are not satisfied, you can also complain through the following channels:Support@zkdigimax.com</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">In principle, we do not charge fees for your reasonable requests, but we will charge a certain cost for repeated requests that exceed reasonable limits. We may reject requests that are unreasonably repeated, require too many technical means (for example, require the development of new systems or fundamentally change existing practices), pose risks to the legitimate rights and interests of others, or are extremely impractical (for example, involving information stored on backup tapes).</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">We will be unable to respond to your request in the following circumstances:</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">1、Related to the personal information controller's performance of obligations prescribed by laws and regulations;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">2、Directly related to national security and national defense security;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">3、Directly related to public safety, public health, and major public interests;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">4、Directly related to criminal investigation, prosecution, trial and execution of judgment;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">5、The personal information controller has sufficient evidence to show that the personal information subject has subjective malice or abuses his rights;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">6、For the purpose of protecting the life, property and other major legitimate rights and interests of the personal information subject or other individuals, but it is difficult to obtain the consent of the individual;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">7、Responding to the request of the Personal Information Subject will cause serious damage to the legitimate rights and interests of the Personal Information Subject or other individuals or organizations; </span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">8、Involving trade secrets.</span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px"></span>四、How do we handle personal information of minors?</strong>
    </p>

    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">Our products, websites and services are primarily intended for adults. Minors should not create their own personal information subject accounts without the consent of their parents or guardians. If you are a minor, we recommend that you ask your parents or guardians to read this policy carefully and use our services or provide us with information only with the consent of your parents or guardians.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">In the case of collecting personal information of minors with parental consent, we will only use or disclose this information when permitted by law, with the explicit consent of parents or guardians, or when necessary to protect minors.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">If we find ourselves collecting personal information of minors without prior verifiable parental consent, we will try to delete the relevant data as quickly as possible.</span></p>

    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">五、How this Policy is Updated</span></strong>
    </p>

    <p style="text-indent: 2em;margin-top: 25px;"><span style="font-size: 14px">Our personal information protection and privacy policies may change.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">Without your explicit consent, we will not reduce your rights under this policy. We will post any changes to this policy on this page.</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">For major changes, we will also provide more prominent notices (including for certain services, we will send notices via email to explain the specific changes to the personal information protection policy).</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">Major changes referred to in this policy include but are not limited to:</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">1、Our service model has undergone major changes, such as the purpose of processing personal information, the type of personal information processed, and the way personal information is used;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">2、We have major changes in ownership structure, organizational structure, etc., such as changes in ownership caused by business adjustments, bankruptcy and mergers and acquisitions, etc.;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">3、The main objects of sharing, transfer or public disclosure of personal information have changed;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">4、There are significant changes in your rights to participate in the processing of personal information and how to exercise them;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">5、When our responsible department for handling personal information security, contact information and complaint channels change;</span></p>
    <p style="text-indent: 2em"><span style="font-size: 14px">We will also archive previous versions of this policy for your reference.</span></p>
    <p style="margin-top: 35px">
        <strong><span style="font-size: 14px">六、How to Contact Us</span></strong>
    </p>
    <p style="text-indent: 2em"><span style="font-size: 14px">If you have any questions, comments or suggestions about this Personal Information Protection and Privacy Policy, please contact us by the following means: Send your questions toSupport@zkdigimax.comIn general, we will7More contact information will be on our official website（http://www.zkteco.com）On the announcement.</span></p>

`,

      user_agree: "Data Processing Agreement",
      user_agree_text: `<p style="text-align: center"><strong>Data Processing Agreement</strong></p>
    <p>Version number :<span> V2.0</span></p>
    <p>Date :<span> October,2024</span></p>
    <p><span>Preface</span></p>
    <p><span>Welcome Nutag Software and services!</span></p>
    <p><span>Email: support@zkdigimax.com</span></p>
    <p style="text-indent: 2em; margin-top: 30px">
      <span
        >ZKTechnology is fully aware of the importance of personal data to you
        and will do its best to protect your personal data. We are committed to
        maintaining your trust in us and abiding by the following principles to
        protect your personal data: the principle of consistency of rights and
        responsibilities, the principle of clear purpose, the principle of
        choice and consent, the principle of minimum necessity, the principle of
        ensuring security, the principle of subject participation, the principle
        of openness and transparency, etc. At the same time, ZKTechnology
        promises that we will take corresponding security protection measures to
        protect your personal data in accordance with the industry's mature
        security standards.</span
      >
    </p>
    <p style="text-indent: 2em; margin-top: 10px">
      <span
        >Please read carefully and fully understand the terms and conditions.
        Unless you have read and accepted all the terms and conditions of this
        Agreement, you have no right to download, install or use this software
        and related services.NutagUsing the software, logging into an account,
        and other actions will be deemed as the user having read and agreed to
        be bound by this agreement.</span
      >
    </p>
    <p style="margin-top: 20px"><span> 一、Scope of application of the agreement</span></p>
    <p style="text-indent: 2em;margin-top: 20px">
      <span
        >This Agreement is an agreement between the user and ZKTechnology
        regarding the user's downloading, installation, and use of this
        software, as well as the use of ZKTechnology's related services.Xiamen
        ZKTechnology Co., Ltd.The operating affiliates that may exist in the
        Software and its related services are referred to as "we" in this
        Agreement. "User" refers to an individual or organization that
        registers, logs in, uses the Software and its services and obtains
        management permissions, and is referred to as "you" in this
        Agreement.</span
      >
    </p>

    <p style="margin-top: 20px"><span>II. Scope of data processing</span></p>
    <p style="text-indent: 2em;margin-top: 10px">
      <span
        >In the process of providing you with relevant services, personal data
        will be collected. Please see the information listed in the table below
        for details.</span
      >
    </p>
    <table style="width: auto;border-collapse: collapse;  margin: 0 auto;">
      <tbody>
        <tr>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">Business Scenario</td>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">Business Activities</td>
          <td colspan="1" rowspan="1" width="245" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">Data List</td>
          <td colspan="1" rowspan="1" width="245" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            Categories of data subjects
          </td>
          <td colspan="1" rowspan="1" width="245" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            Data processing activities involved and purpose of use
          </td>
        </tr>

        <tr>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            We provide remote technical support to users
          </td>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            We may access users' personal data during software implementation
            and operation and maintenance
          </td>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            Username (name/nickname/alias/code), phone number, email、Account
            and Password
          </td>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">user</td>
          <td colspan="1" rowspan="1" width="182" style="border: 1px solid black; padding: 8px; text-align: left; text-align: center;">
            Storage, analysis and deletion of personal data;Used for business
            information display and analysis, including display, update, data
            maintenance, personal tagging, security traceability, business
            requirements, research, basic maintenance, account management
          </td>
        </tr>
      </tbody>
    </table>
    <p><span>III. Definition</span></p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >Unless otherwise agreed by the Parties, the definitions of terms used
        in this Agreement are listed below in alphabetical order.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(1) "Data Subject” means an identified or identifiable natural person.
        An identifiable natural person is one who can be identified, directly or
        indirectly, in particular by reference to an identifier such as a name,
        identification number, location data, an online identifier or one or
        more factors specific to the physical, physiological, genetic, mental,
        economic, cultural or social identity of that natural person.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(2) “EU Standard Contractual Clauses” means the standard contractual
        clauses for the transfer of personal data to processors established in
        third countries not ensuring an adequate level of data protection as set
        out in Article 44 of Regulation (EC) No 79 of 2016 (and pursuant to
        Article 26(2) of Directive 95/46/EC), as published on the relevant
        website of the European Commission and as may be amended or updated from
        time to time.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(3) “Personal Data” means any information relating to an identified or
        identifiable natural person (“data subject”).</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(4) “Personal Data Breach” means a security breach in accordance with
        local data protection laws and regulations, including but not limited to
        accidental or unlawful destruction, loss, alteration, unauthorized
        disclosure of, or access to, personal data transmitted, stored or
        otherwise processed.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(5) “Privacy Laws” means any potentially applicable laws and/or
        regulations relating to the security and protection of personal data
        (such as the GDPR or other applicable privacy protection laws of other
        countries), any laws and regulations implemented or enacted thereunder,
        and any revised, updated or re-enacted versions of such laws and
        regulations.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(6) “Regulatory Bodies” means government departments, regulatory
        agencies, statutory bodies and other institutions that have the power to
        supervise, investigate or influence matters related to data security and
        the protection of personal data and privacy in accordance with statutes,
        rules, regulations, codes of practice or other documents.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(7) “Service” refers to the services involving the processing of
        personal data provided by ZKTechnology in accordance with the specific
        service agreement and other contractual texts concluded with the
        user..</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(8) “Sub-processor” refers to an organization or individual other than
        ZK Technology and related groups that is involved in the processing of
        personal information.</span
      >
    </p>
    <p><span>IV. Data Processing Requirements</span></p>
    <p style="text-indent: 2em;margin-top: 20px"><span>(I). Data processing principles</span></p>

    <p style="text-indent: 2em;margin-top: 10px">
      <span style="text-indent: 18pt"
        >We process personal data in accordance with the general principles of
        "lawfulness, legitimacy, transparency, purpose limitation, data
        minimization, accuracy, minimization of storage period, integrity and
        confidentiality, and accountability". We will carry out data processing
        activities in accordance with your instructions, and shall not exceed
        your instructions and the purposes and scope agreed in this Agreement,
        and shall not use personal data for any other purpose. If we believe
        that your instructions violate applicable data protection regulations,
        we will notify you immediately. We will fully support you in protecting
        the rights of data subjects, such as access, correction, and deletion.
      </span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt;margin-top: 10px"
        >We will follow the clock source configuration provided by the cloud
        service provider. If the service method/service content of our products
        changes, we will inform you by email as soon as possible.</span
      >
    </p>
    <p style="text-indent: 2em;margin-top: 20px">
      <span>(II) Processing of special categories of personal data</span>
    </p>
    <p style="text-indent: 2em;margin-top: 10px">
      <span style="text-indent: 18pt;margin-top: 10px"
        >We do not process any personal data that could reveal racial or ethnic
        origin, political opinions, or trade union membership, or any biometric
        data that uniquely identifies a natural person, in a manner that
        violates applicable data protection regulations.</span
      >
    </p>

    <p style="text-indent: 2em;margin-top: 20px">
      <span>(III) Cross-border transfer of personal data</span>
    </p>
    <p style="text-indent: 2em;margin-top: 10px">
      <span style="text-indent: 18pt"
        >No personal data involvedCross-border processing.</span
      >
    </p>
    <p style="text-indent: 2em;;margin-top: 20px"><span>(IV) Data security</span></p>
    <p style="text-indent: 2em;margin-top: 20px">
      <span style="text-indent: 18pt;margin-top: 20px"
        >During the processing of personal data, we take effective technical and
        organizational measures in accordance with applicable data protection
        regulations and your requirements to ensure that personal data that may
        be exposed during the data processing process is kept confidential with
        confidentiality measures no less confidential than our own information,
        and shall not be disclosed to any third party without your written
        permission to protect personal data from leakage.</span
      >
    </p>
    <p style="text-indent: 2em;margin-top: 20px">
      <span>(V) Data leakage incident emergency response mechanism</span>
    </p>

    <p style="text-indent: 2em;margin-top: 10px">
      <span style="text-indent: 18pt"
        >1. After discovering a personal data breach, we willVII.（72) hours
        after the date of the notification to you in writing to fulfil the
        obligation to notify the supervisory authority and the data subject
        under the applicable data protection legislation. Such notification
        shall include the following:</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(1) An overview of the impact of the personal data breach, including
        but not limited to a description of the nature of the personal data
        breach, the categories and number of data subjects involved, and the
        relevant personal data processing records.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(2) The risks and consequences that may result from the leakage of
        personal data.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(3) The measures we have taken or suggestions we have made to address
        personal data breaches.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(4) The name and contact details of our Data Protection Officer,
        Privacy Officer and any relevant contact person who can provide further
        information.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(5) Any other information you reasonably request related to the
        personal data breach.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(6) If the above information cannot be provided at the same time, it
        shall be provided in stages within thirty-six (36) hours or within the
        time requested by you.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >2. For any personal data leakage that occurs, we will immediately
        investigate, identify, prevent and reduce the impact, and take necessary
        remedial measures with your prior consent.</span
      >
    </p>
    <p style="margin-top: 20px">
      <span>(VI) Introduction of Sub-processors</span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >1. We will not subcontract or outsource any personal data processing
        business to subprocessors without your permission.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >2. We shall sign a data processing agreement with the subprocessor and
        conduct due diligence in accordance with applicable legal requirements.
        We will pass your request to the subprocessor and be responsible for any
        negative impact or adverse consequences caused by the data processing
        activities of the subprocessor or any third party designated by
        it.</span
      >
    </p>

    <p style="margin-top: 20px"><span>(VII) Deletion of Personal Data</span></p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >Unless otherwise required or required by data protection legislation,
        upon your request, we will delete the relevant personal data immediately
        once we have fulfilled our obligations under the applicable agreement
        between the parties and have proved to you that we have fulfilled this
        obligation.</span
      >
    </p>
    <p style="margin-top: 20px"><span>(VIII) Cloud Platform Security Responsibilities</span></p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >1、ZK is responsible for the security management and operation of
        services and data interactions on the ZK cloud platform, and is
        responsible for the security of the cloud service platform and
        infrastructure it provides. Customers access the ZK cloud platform by
        calling API interfaces, self-developed software developed by SDK, or
        hardware embedded software, and they need to ensure the security and
        compliance of their applications and data, including hardware equipment
        and software. The main responsibility of ZK Cloud is to develop and
        operate various basic services, platform services, and application
        services, while the main responsibility of the customer is to customize
        and develop third-party clients and build third-party cloud services
        based on ZK cloud services. The figure below shows a model of shared
        responsibility for information security among basic cloud service
        providers, ZK, and customers.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span>2、Security Responsibilities of ZK Cloud</span>
    </p>

    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(1) ZK Cloud selects world-renowned cloud hosting service providers
        such as Amazon, Tencent Cloud, and Alibaba Cloud to ensure the security
        of infrastructure and physical equipment for secure management and
        operation.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(2) ZK Cloud Security covers data security and cloud service security.
        ZK promises to use its security team and the professional attack
        protection technology experience of world-renowned security service
        providers to provide cloud platform security operation and maintenance
        services, effectively protect the security operation of ZK Cloud, and
        safeguard the privacy and data security of customers and users.
        Including but not limited to:</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >a. Data security: refers to the security management of customers'
        business data in the cloud business environment, including collection
        and identification, classification and grading, permissions and
        encryption, and privacy compliance.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >b. Access control management: management of access rights to resources
        and data, including user management, permission management, identity
        authentication, etc.;</span
      >
    </p>
    <p style="text-indent: 2em">
      <span
        >c. Cloud service security: refers to the security management of
        business-related application systems in a cloud computing environment,
        including the design, development, release, configuration and use of
        applications and service interfaces.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span>3. Customer's safety responsibility</span>
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(1) When using ZK Cloud solutions, customers must strictly follow ZK's
        security configuration and access requirements. At the same time,
        customers must ensure the security of their own cloud, client, or
        hardware products.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(2) For application software developed based on ZK SDK/API, ZK only
        provides technical support but cannot provide security protection for
        the entire software.</span
      >
    </p>
    <p style="text-indent: 2em">
      <span style="text-indent: 18pt"
        >(3) The customer is responsible for data security compliance, privacy
        policy and other related information, privacy policy statements and
        legal compliance for customized products based on ZK solutions. When
        necessary, ZK's security compliance team is willing to provide
        assistance and consulting services for security solutions.</span
      >
    </p>

    <p style="margin-top: 20px"><span>(IX) Data backup</span></p>
    <p style="text-indent: 2em">
      <span
        >To prevent data loss due to unforeseen reasons such as hardware failure
        and natural disasters, we will regularly back up the cloud database and
        keep it consistent with (IV) Data Security. The backup frequency is once
        a day, and the backup data is encrypted and stored. We will delete your
        relevant backups within 7 days in accordance with the law when the
        service ends.</span
      >
    </p>
    <p style="margin-top: 20px"><span>V. Responsibility</span></p>
    <p style="text-indent: 2em">
      <span
        >As the data controller, you are responsible for complying with
        applicable data protection regulations. You are obliged to assess the
        lawfulness of the processing of personal data stored on the software.
        You should ensure that any disclosure of personal data to us is lawful.
      </span>
    </p>
    <p style="margin-top: 20px"><span>VI. Audit Rights</span></p>
    <p style="text-indent: 2em">
      <span
        >You may review our compliance with the terms of the Agreement and this
        Data Processing Agreement on an annual basis.</span
      >
    </p>
    <p style="margin-top: 20px"><span>VII. Applicable Law</span></p>
    <p style="text-indent: 2em">
      <span
        >This Agreement will be governed by the laws of the Member State in
        which the User is domiciled.</span
      >
    </p>`,
},
};
